import { Fragment } from "react";
import "./ContactSection.css";

const ContactSection = () => {
  return (
    <Fragment>
      <section className="contact-section">
        <div className="container">
          <div
            className="section-title"
            data-aos="fade-down"  
            data-aos-duration="800"
          >
            <div className="text-uppercase">Contact</div>
            <h4 className="text-uppercase">Let's Connect</h4>
          </div>
          <div className="col-lg-12 location-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.069211003627!2d80.1646995!3d12.9226721!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9f8bd89bdca64146!2sKairaa%20Techserve!5e0!3m2!1sen!2sin!4v1669376896234!5m2!1sen!2sin"
              style={{ border: "0" }}
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div className="row">
            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
              <div className="overlap">
                <div className="contact-input">
                  <h1 className="text-capitalize text-center mb-4">
                    get in touch
                  </h1>
                  <form>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your name"
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your email id"
                      />
                    </div>
                    <div className="mb-3">
                      <textarea
                        className="form-control"
                        type="text"
                        placeholder="Write your message..."
                      ></textarea>
                    </div>
                    <div className="mb-3 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Save my name, email, and website in this browser for the next time. 
                      </label>
                    </div>
                    <button type="submit" className="btn send-btn">
                      <span>Send Message</span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default ContactSection;
